<template>
  <div
    v-if="availableItems.length"
    class="relative flex flex-col gap-24 text-[1.4rem]"
  >
    <h2 class="heading-3">
      <slot name="title">{{ i18n(translations.title) }}</slot>
    </h2>

    <CheckoutSummaryContent
      data-qa="order-details"
      :discount
      :discount-token
      :items="availableItems"
      :methods-features
      :selected-payment-method
      :summary
      :swap-offer
      :with-extended-legal
      :with-payment-availability
    />

    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { BuybackOffer } from '@backmarket/http-api'
import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import type { PaymentMethodsFeatures } from '@backmarket/nuxt-layer-payment/methods'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type {
  CartItem,
  CartSummary,
} from '@backmarket/nuxt-layer-checkout/api/cart/types'
import { getAvailableItems } from '@backmarket/nuxt-layer-checkout/utils/cart/getAvailableItems'

import type { Discount } from '../../types/discount'

import translations from './CheckoutSummary.translations'
import CheckoutSummaryContent from './components/CheckoutSummaryContent/CheckoutSummaryContent.vue'

const i18n = useI18n()

const props = withDefaults(
  defineProps<{
    items: CartItem[]
    summary: CartSummary
    swapOffer: BuybackOffer | null
    discount: Discount
    discountToken: string
    selectedPaymentMethod?: PaymentMethod | null
    withPaymentAvailability?: boolean
    withExtendedLegal?: boolean
    showEstimatedTaxes?: boolean
    showFinalTaxes?: boolean
    methodsFeatures?: PaymentMethodsFeatures
  }>(),
  {
    withPaymentAvailability: false,
    withExtendedLegal: false,
    selectedPaymentMethod: null,
    methodsFeatures: undefined,
    showEstimatedTaxes: true,
    showFinalTaxes: false,
  },
)

const availableItems = computed(() => getAvailableItems(props.items))
</script>
